"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartBoxCard = void 0;
const ChartVariant_1 = __importDefault(require("@opsbase/lib-chart/ChartVariant"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const DashboardIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DashboardIcon"));
const Card_1 = __importDefault(require("@opsbase/web-layout/Card"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const ChartBoxCountGroupCard_1 = __importDefault(require("./ChartBoxCountGroupCard"));
const ChartBoxCountGroupTimeCard_1 = __importDefault(require("./ChartBoxCountGroupTimeCard"));
const ChartBoxCountTimeCard_1 = __importDefault(require("./ChartBoxCountTimeCard"));
const ChartBoxScoreQOpCard_1 = __importDefault(require("./ChartBoxScoreQOpCard"));
const makeMyClasses = () => ({
    button: {
        position: 'absolute',
        top: 4,
        left: 4,
        backgroundColor: lib_palette_1.default.BackgroundGrey.main,
    },
});
function ChartBoxCard(props) {
    const { chart, onAddToDashboard } = props;
    const shrink = (chart === null || chart === void 0 ? void 0 : chart.chartVariant) === ChartVariant_1.default.COUNT_GROUP;
    const canAddToDashboard = !!onAddToDashboard;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleAddToDashboard = (0, react_1.useCallback)(() => {
        onAddToDashboard(chart);
    }, [onAddToDashboard, chart]);
    const chartBit = (0, react_1.useMemo)(() => {
        switch (chart.chartVariant) {
            case ChartVariant_1.default.COUNT_GROUP:
                return react_1.default.createElement(ChartBoxCountGroupCard_1.default, Object.assign({}, props));
            case ChartVariant_1.default.COUNT_TIME:
                return react_1.default.createElement(ChartBoxCountTimeCard_1.default, Object.assign({}, props));
            case ChartVariant_1.default.COUNT_GROUP_TIME:
                return react_1.default.createElement(ChartBoxCountGroupTimeCard_1.default, Object.assign({}, props));
            case ChartVariant_1.default.SCORE_Q_OP:
                return react_1.default.createElement(ChartBoxScoreQOpCard_1.default, Object.assign({}, props));
        }
    }, [chart.chartVariant, props]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Card_1.default, { grow: !shrink, shrink: shrink, padding: true },
        chartBit,
        !!canAddToDashboard && (react_1.default.createElement(IconButton_1.default, { size: 20, icon: react_1.default.createElement(DashboardIcon_1.default, { color: lib_palette_1.default.GreyBlue, size: 14 }), classes: { root: myCss.button }, tooltip: lib_i18n_1.default.t('add-to-dashboard'), tooltipDelay: 100, onClick: handleAddToDashboard })))), [shrink, chartBit, canAddToDashboard, myCss, handleAddToDashboard]);
}
exports.ChartBoxCard = ChartBoxCard;
exports.default = ChartBoxCard;
